import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }

import {computed, onBeforeMount, onMounted, onUpdated, ref} from "vue";
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButton,
  IonIcon,
  IonRippleEffect,
  IonFab, IonFabButton,
  onIonViewDidEnter, onIonViewDidLeave, alertController, toastController
} from "@ionic/vue";

import UserTrackingTemplateOverview from "@/components/profile/userTracking/UserTrackingTemplateOverview.vue";
import {RouteParams, useRoute} from "vue-router";
import UserTrackingTemplateDetail from "@/components/profile/userTracking/UserTrackingTemplateDetail.vue";
import * as icons from 'ionicons/icons';
import UserTrackingTemplateEdit from "@/components/profile/userTracking/UserTrackingTemplateEdit.vue";
import router from "@/router";
import {AxiosError, AxiosResponse} from "axios";
import {MobiPointApiProfile} from "@/mobipoints/api/profile";
import useData from "@/composable/useData";


import {defineComponent} from "vue";
//  explicit name definition not required
const __default__ = defineComponent({
  name: "UserTrackingTemplate",
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const content = ref<InstanceType<typeof IonContent> | null>(null);
const userTrackingTemplateEdit = ref<InstanceType<typeof UserTrackingTemplateEdit> | null>(null);
const userTrackingTemplateDetail = ref<InstanceType<typeof UserTrackingTemplateDetail> | null>(null);
const userTrackingTemplateOverview = ref<InstanceType<typeof UserTrackingTemplateOverview> | null>(null);
const scroll = ref(false);
const currentRouteName = ref<string>();
const currentRouteParams = ref<RouteParams>();
const userTrackingTemplateId = computed(() => {
  return Number(currentRouteParams.value && currentRouteParams.value.id);
});
const {getTextValueByKey} = useData();
const backButtonText = ref(getTextValueByKey('overview.back.button.text', [], ''));

onBeforeMount(() => {
  const currentRoute = useRoute();
  currentRouteName.value = String(currentRoute.name);
  currentRouteParams.value = currentRoute.params || {};
});

onUpdated(() => {
  // console.log("UPDATE: content is", content.value);
});

const deleteUserTrackingTemplate = async function (id: number) {
  const alert = await alertController.create({
    header: 'Sicherheitsabfrage:',
    message: 'Tracking Vorlage wirklich löschen?',
    buttons: [
      {
        text: 'Nein',
        role: 'cancel',
        cssClass: 'secondary',
      },
      {
        text: 'Ja',
        cssClass: 'danger',
        handler: async function () {
          let response: AxiosResponse | null = null;
          let message = '';
          try {
            response = await MobiPointApiProfile.deleteUserTrackingTemplate(id);
            if (!response.data.status || response.data.status !== 'error') {
              if (currentRouteName.value === 'UserTrackingTemplateDetail') {
                router.replace({
                  name: 'UserTrackingTemplateOverview',
                })
              } else {
                router.back();
              }

              return;
            }

            message = `Could not delete tracking template error: ${response.data.message || 'Unkown'}` || message;
          } catch (error: any | AxiosError) {
            message = `Could not delete tracking template! Please try again :)`;
          }

          const toast = await toastController.create({
            message: message,
            position: 'bottom',
            duration: 3000,
            icon: icons.warning,
            buttons: [
              {
                side: 'end',
                role: 'cancel',
                icon: icons.close,
              }
            ],
          });

          return toast.present();
        },
      },
    ]
  });

  return alert.present();
};

const editUserTrackingTemplate = (id: number) => {
  router.replace({
    name: 'UserTrackingTemplateEdit',
    params: {id: id}
  });
};

const cancelUserTrackingTemplate = () => {
  if (currentRouteName.value === 'UserTrackingTemplateEdit') {
    router.replace({
      name: 'UserTrackingTemplateDetail',
      params: {id: userTrackingTemplateId.value}
    });
  } else if(currentRouteName.value === 'UserTrackingTemplateAdd') {
    router.replace({
      name: 'UserTrackingTemplateOverview',
    });
  } else {
    router.back();
  }
};

const saveUserTrackingTemplate = async function (): Promise<boolean> {
  const valid = await userTrackingTemplateEdit.value.validateUserTrackingTemplate();
  if (!valid) {
    return false;
  }
  const response = await userTrackingTemplateEdit.value.saveUserTrackingTemplate();

  if (currentRouteName.value === 'UserTrackingTemplateEdit') {
    await router.replace({
      name: 'UserTrackingTemplateDetail',
      params: {id: userTrackingTemplateId.value}
    });
  } else if(currentRouteName.value === 'UserTrackingTemplateAdd') {
    await router.replace({
      name: 'UserTrackingTemplateOverview',
    });
  }

  return null !== response;
};


const addUserTrackingTemplate = () => {
  router.replace({
    name: 'UserTrackingTemplateAdd',
  });
}

const toogleReorderUserTrackingTemplates = () => {
  userTrackingTemplateOverview.value.toggleReorderDisabled();
}

// onIonViewDidEnter(() => console.log("PAGE DID ENTER UserTrackingTemplate"));
// onIonViewDidLeave(() => console.log("PAGE DID LEAVE UserTrackingTemplate"));

return (_ctx: any,_cache: any) => {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  (currentRouteName.value === 'UserTrackingTemplateDetail')
                    ? (_openBlock(), _createBlock(_unref(IonButton), {
                        key: 0,
                        shape: "round",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace({ name: 'UserTrackingTemplateOverview' })))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "start",
                            icon: icons.arrowBackOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (currentRouteName.value === 'UserTrackingTemplateEdit')
                    ? (_openBlock(), _createBlock(_unref(IonButton), {
                        key: 1,
                        shape: "round",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.replace({ name: 'UserTrackingTemplateDetail', params : {id : userTrackingTemplateId.value} })))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "start",
                            icon: icons.arrowBackOutline
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (currentRouteName.value === 'UserTrackingTemplateOverview')
                    ? (_openBlock(), _createBlock(_unref(IonBackButton), {
                        key: 2,
                        text: backButtonText.value,
                        "default-href": "/profile"
                      }, null, 8, ["text"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Meine Tracking Vorlagen")
                ]),
                _: 1
              }),
              (currentRouteName.value === 'UserTrackingTemplateDetail')
                ? (_openBlock(), _createBlock(_unref(IonButtons), {
                    key: 0,
                    slot: "end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (deleteUserTrackingTemplate(userTrackingTemplateId.value)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            icon: icons.trashOutline
                          }, null, 8, ["icon"]),
                          _createVNode(_unref(IonRippleEffect))
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonButton), {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (editUserTrackingTemplate(userTrackingTemplateId.value)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            icon: icons.pencilOutline
                          }, null, 8, ["icon"]),
                          _createVNode(_unref(IonRippleEffect))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (currentRouteName.value === 'UserTrackingTemplateOverview')
                ? (_openBlock(), _createBlock(_unref(IonButtons), {
                    key: 1,
                    slot: "end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), { onClick: toogleReorderUserTrackingTemplates }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            icon: icons.reorderTwoOutline
                          }, null, 8, ["icon"]),
                          _createVNode(_unref(IonRippleEffect))
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonButton), { onClick: addUserTrackingTemplate }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            icon: icons.add
                          }, null, 8, ["icon"]),
                          _createVNode(_unref(IonRippleEffect))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        ref_key: "content",
        ref: content
      }, {
        default: _withCtx(() => [
          (currentRouteName.value === 'UserTrackingTemplateOverview')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(UserTrackingTemplateOverview, {
                  ref_key: "userTrackingTemplateOverview",
                  ref: userTrackingTemplateOverview,
                  "show-scroll-to-top": scroll.value
                }, null, 8, ["show-scroll-to-top"])
              ]))
            : _createCommentVNode("", true),
          (currentRouteName.value === 'UserTrackingTemplateDetail')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(UserTrackingTemplateDetail, {
                  ref_key: "userTrackingTemplateDetail",
                  ref: userTrackingTemplateDetail,
                  "user-tracking-template-id": userTrackingTemplateId.value
                }, null, 8, ["user-tracking-template-id"])
              ]))
            : _createCommentVNode("", true),
          (currentRouteName.value === 'UserTrackingTemplateEdit')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(UserTrackingTemplateEdit, {
                  ref_key: "userTrackingTemplateEdit",
                  ref: userTrackingTemplateEdit,
                  "user-tracking-template-id": userTrackingTemplateId.value
                }, null, 8, ["user-tracking-template-id"])
              ]))
            : _createCommentVNode("", true),
          (currentRouteName.value === 'UserTrackingTemplateAdd')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(UserTrackingTemplateEdit, {
                  ref_key: "userTrackingTemplateEdit",
                  ref: userTrackingTemplateEdit
                }, null, 512)
              ]))
            : _createCommentVNode("", true),
          (currentRouteName.value === 'UserTrackingTemplateOverview')
            ? (_openBlock(), _createBlock(_unref(IonFab), {
                key: 4,
                vertical: "bottom",
                horizontal: "end",
                slot: "fixed"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonFabButton), { onClick: addUserTrackingTemplate }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        size: "large",
                        icon: icons.add
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512),
      (currentRouteName.value === 'UserTrackingTemplateEdit' || currentRouteName.value === 'UserTrackingTemplateAdd')
        ? (_openBlock(), _createBlock(_component_ion_footer, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonToolbar), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    slot: "start",
                    color: "medium",
                    class: "ion-margin-start",
                    onClick: cancelUserTrackingTemplate
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        icon: icons.close
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { style: {"margin-left":".25rem"} }, {
                        default: _withCtx(() => [
                          _createTextVNode("Cancel")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonRippleEffect))
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonButton), {
                    slot: "end",
                    class: "ion-margin-end",
                    onClick: saveUserTrackingTemplate
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        icon: icons.save
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { style: {"margin-left":".5rem"} }, {
                        default: _withCtx(() => [
                          _createTextVNode("Save")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonRippleEffect))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})